const IS_MOBILE = 'ontouchstart' in document.documentElement;

export default IS_MOBILE;
